<div *ngIf="product$"
      class="container mb-pdp-tab-content mb-specifications-tab"
      data-cy="mb-specifications-tab">

  <div *ngIf="specifications$ | async as specifications"
        class="mb-pdp-tab-wrapper mb-specs-tab">

    <div class="row no-gutters">
      <div class="col-12 p-0 mb-specs-headline"
            data-cy="mb-specs-heading">
        {{'mbProductTabs.specificationsFor' | mbTranslate}} <strong [innerHTML]="productName | safeHtml"></strong>
      </div>
    </div>

      <!-------------------Overview Dataset------------------------>

      <ng-container *ngIf="specifications.overviewEntries && specifications.overviewEntries.length">
        <div class="row no-gutters">
          <div class="col-12 mb-specs-headline mb-specs-sub-headline" data-cy="mb-specs-overview-heading"> {{'mbProductTabs.specsOverview' | mbTranslate}}</div>
          <div *ngFor="let overviewEntry of specifications.overviewEntries; index as i"
                class="col-12 mb-specs-sub-headline"
                [innerHTML]="overviewEntry.text | safeHtml"
                [attr.data-cy]="'mb-specs-overview-text-' + i">
          </div>
        </div>
      </ng-container>

      <!-------------------Detailed Info Dataset------------------------>
      <ng-container *ngIf="specifications.detailedInfoEntries && specifications.detailedInfoEntries.length">
        <div class="row no-gutters">
          <div class="col-12 mb-specs-headline mb-specs-sub-headline mb-3" data-cy="mb-specs-detailed-info-heading">{{'mbProductTabs.detailedProductInfo' | mbTranslate}}</div>

          <ng-container *ngFor="let detailedInfoEntry of specifications.detailedInfoEntries; index as i">

            <!------------- HTML Text data ------------------->
            <ng-container *ngIf="detailedInfoEntry.type === mbDatasetEntryTypes.HTML_TEXT">
              <div class="col-12 mb-specs-info"   [attr.data-cy]="'mb-specs-detailed-info-text-' + i" [innerHTML]="detailedInfoEntry.text | safeHtml"></div>
            </ng-container>

            <!------------- Table Entry data ------------------->
            <ng-container *ngIf="detailedInfoEntry.type === mbDatasetEntryTypes.TABLE">
              <div class="col-12 col-md-10 mb-table-detail-info"   [attr.data-cy]="'mb-specs-detailed-info-table-entry-' + i">
                <div class="row no-gutters ">
                  <div class="col col-sm-4 pr-2 mb-specs-table-header"  [attr.data-cy]="'mb-specs-detailed-info-table-header-' + i" [innerHTML]="detailedInfoEntry.header | safeHtml"></div>
                  <div class="col col-sm-8 mb-specs-table-value"  [attr.data-cy]="'mb-specs-detailed-info-table-value-' + i" [innerHTML]="detailedInfoEntry.value | safeHtml"></div>
                </div>
              </div>
            </ng-container>

            <!------------- Image data ------------------->
            <ng-container *ngIf="detailedInfoEntry.type === mbDatasetEntryTypes.IMAGE">
              <div class="col-12 mb-detailed-info-image">
                <img [src]="detailedInfoEntry?.url"
                     class="img-responsive"
                     title="Specification detailed information image"
                     alt="Specification detailed information image"
                     aria-label="Specification detailed information image"
                     [attr.data-cy]="'mb-detailed-information-image-' + i"/>
                <div *ngIf="detailedInfoEntry?.description" class="mt-3 mb-detailed-info-image-description"
                     [attr.data-cy]="'mb-detailed-information-image-description-' + i"
                     [innerHTML]="detailedInfoEntry?.description | safeHtml">
                </div>
              </div>
            </ng-container>

        </ng-container>
        </div>
      </ng-container>

  </div>
</div>
